import { ApolloLink } from 'apollo-link';

/**
 * RequestIdLink extracts the requestId from the operation context (set by the `useQueryInterop` hook)
 * and adds it to the request headers so it can be accessed in the fetch function.
 *
 * When requestId is present, this link also sets `single: true` in the context
 * to ensure the request is sent individually (not batched).
 */
export const requestIdLink = new ApolloLink((operation, forward) => {
	const context = operation.getContext();
	const requestId = context.requestId;

	if (requestId) {
		operation.setContext((prevContext: any) => ({
			...prevContext,
			single: true, // Prevent batching when requestId is present
			headers: {
				...prevContext.headers,
				'X-Request-Id': requestId,
			},
		}));
	}

	return forward(operation);
});
